import axios from 'axios';
import bcrypt from 'bcryptjs';
import { LoginRequest, ProcessResult, SessionData } from "../Interfaces";
import { getLoginEndpoint, getLogoutEndpoint } from '../Endpoints';
import { getAppName, getLocalStorageAuthVariableName, parseJWT } from '../Utils';

export const requestLogout = async (sessionId: string, token: string): Promise<ProcessResult> => {
    try{
        const requestResult = await axios.put(`${getLogoutEndpoint}/${sessionId}`, {}, {
            headers: {
                ApplicationId: getAppName(),
                authenticate: `bearer ${token}`,
            },
        });

        if(requestResult?.data?.ResultCode === 0){
            return {Ok: true};
        }

        return {Ok: false};
    }catch(error: any){
        console.error("Error on logout >>> ", JSON.stringify(error));
        return {Ok: false, data: error.message};
    }
}

export const requestLogin = async ({UserName, Password}: LoginRequest): Promise<ProcessResult> => {
    try{
        const hashedPassword = bcrypt.hashSync(Password ?? '', process.env.REACT_APP_BCRYPT_SALT);

        const requestResult = await axios.post(getLoginEndpoint, {
            UserName: UserName,
            Password: hashedPassword,
        },
        {
            headers: {
                ApplicationId: getAppName(),
              },
        }
        );

        if(requestResult?.data?.ResultCode === 0){  
            
            const parsedData = parseJWT(requestResult.data.Data);
            const userData = JSON.parse(parsedData.data);

            localStorage.setItem(getLocalStorageAuthVariableName(), JSON.stringify({
                token: requestResult.data.Data,
                tokenType: 'bearer',
                authState: userData,
                expiresIn: 99999999,
            }));

            return {Ok: true};
        }

        return {Ok: false};
    }
    catch (error: any){
        console.error("Error on login >>> ", JSON.stringify(error));
        return {Ok: false, data: error.message};
    }
}

export function useAuthentication (): SessionData {
    try{
        const auth = localStorage.getItem(getLocalStorageAuthVariableName());
        if(!auth) {
            return {isAuthenticated: false};
        }
    
        const parsedData = JSON.parse(auth ?? '');
        if(!parsedData){
            return {isAuthenticated: false};
        }
    
        return {isAuthenticated: true, sessionData: parsedData.authState, token: parsedData.token};
    }
    catch
    {
        return {isAuthenticated: false};
    }
}